import { SelectOption } from '@/components/elements/select'

export const containerSupplemntMap: SelectOption[] = [
	{ label: 'Plástico', value: 'Plástico' },
	{ label: 'Vidrio', value: 'Vidrio' },
	{ label: 'Aluminio', value: 'Aluminio' },
	{ label: 'Cartón', value: 'Cartón' },
	{ label: 'Lata metálica', value: 'Lata metálica' },
	{ label: 'Bolsa plástica', value: 'Bolsa plástica' },
	{ label: 'Bolsa de papel', value: 'Bolsa de papel' },
	{ label: 'Tetra Pak', value: 'Tetra Pak' },
	{ label: 'Frasco PET', value: 'Frasco PET' },
	{ label: 'Blíster', value: 'Blíster' },
]
